export default __webpack_public_path__ + "static/media/50k.04590b70.md";